module.exports = __webpack_public_path__ + "images/bf513ab87e74d4a27a48b98746a6178f.svg";